import React from 'react';

export default function Step({ Number, Label, active = false }) {
  return (
    <div className="flex items-center gap-3">
      <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm border-2 transition-all ${
        active ? 'bg-purple-600 border-purple-600 text-white shadow-lg shadow-purple-500/20' : 'bg-gray-800 border-gray-700 text-gray-500'
      }`}>
        {Number}
      </div>
      <span className={`text-sm font-bold whitespace-nowrap ${active ? 'text-white' : 'text-gray-500'}`}>{Label}</span>
    </div>
  );
}
